import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AuthService, EmpresaOption } from '../core/auth.service';

@Component({
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, FormsModule],
  template: `
    <div class="shell">
      <aside class="sidebar">
        <div class="logo">IGC</div>
        <nav>
          @if (isAdmin()) {
            <a routerLink="/dashboard" routerLinkActive="active">Dashboard</a>
          }
          <a routerLink="/inspecciones" routerLinkActive="active">Inspecciones</a>
          <a routerLink="/mantenimientos" routerLinkActive="active">Mantenimiento</a>
          <a routerLink="/fallas" routerLinkActive="active">Reportes falla</a>
          <a routerLink="/activos" routerLinkActive="active">Activos</a>
          <a routerLink="/pqrs" routerLinkActive="active">PQRS</a>
          <a routerLink="/vehiculos" routerLinkActive="active">Vehiculos</a>
          <a routerLink="/checklists" routerLinkActive="active">Checklists</a>
          <a routerLink="/bpm-personal" routerLinkActive="active">BPM Personal</a>
          <a routerLink="/chequeos-bpm-personal" routerLinkActive="active">Historial BPM</a>
          <a routerLink="/tipos-bpm-personal" routerLinkActive="active">Tipos BPM</a>
          <a routerLink="/control-proceso" routerLinkActive="active">Control proceso</a>
          @if (isAdmin()) {
            <a routerLink="/programas" routerLinkActive="active">Programas PDF</a>
          }
          @if (isSuperAdmin()) {
            <a routerLink="/empresas" routerLinkActive="active">Empresas</a>
            <a routerLink="/sectores" routerLinkActive="active">Sectores</a>
          }
          @if (isAdmin()) {
            <a routerLink="/usuarios" routerLinkActive="active">Usuarios</a>
          }
        </nav>
        <button class="logout" (click)="auth.logout()">Cerrar sesion</button>
      </aside>

      <main class="content">
        <header>
          <div>
            <strong>{{ auth.user()?.nombreCompleto }}</strong>
            <span>{{ auth.user()?.nombreEmpresaActiva || auth.user()?.nombreEmpresa || 'IGC' }}</span>
          </div>
          @if (isSuperAdmin()) {
            <label class="company-picker">
              <span>Empresa activa</span>
              <select [(ngModel)]="empresaSeleccionada" (ngModelChange)="onEmpresaChange($event)">
                @for (empresa of empresas; track empresa.idEmpresa) {
                  <option [ngValue]="empresa.idEmpresa">{{ empresa.nombre }}</option>
                }
              </select>
            </label>
          }
        </header>
        <router-outlet />
      </main>
    </div>
  `,
  styles: [`
    .shell {
      min-height: 100vh;
      display: grid;
      grid-template-columns: 260px minmax(0, 1fr);
    }

    .sidebar {
      display: flex;
      flex-direction: column;
      gap: 20px;
      padding: 20px;
      background: #172033;
      color: white;
    }

    .logo {
      width: fit-content;
      padding: 10px 12px;
      border: 1px solid rgba(255,255,255,.28);
      border-radius: 6px;
      font-weight: 800;
    }

    nav {
      display: grid;
      gap: 6px;
    }

    a,
    .logout {
      color: white;
      text-decoration: none;
      padding: 10px 12px;
      border-radius: 6px;
      background: transparent;
      text-align: left;
    }

    a.active,
    a:hover,
    .logout:hover {
      background: rgba(255,255,255,.12);
    }

    .logout {
      margin-top: auto;
    }

    .content {
      min-width: 0;
      padding: 22px;
    }

    header {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 18px;
      margin-bottom: 18px;
      color: var(--muted);
    }

    header div {
      display: grid;
      gap: 2px;
      text-align: right;
    }

    header strong {
      color: var(--ink);
    }

    .company-picker {
      display: grid;
      gap: 4px;
      min-width: 260px;
      color: var(--muted);
      font-size: 12px;
      font-weight: 700;
    }

    .company-picker select {
      border: 1px solid var(--line);
      border-radius: 6px;
      padding: 9px 10px;
      background: white;
      color: var(--ink);
    }

    @media (max-width: 880px) {
      .shell {
        grid-template-columns: 1fr;
      }

      .sidebar {
        position: sticky;
        top: 0;
        z-index: 2;
      }

      nav {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    }
  `]
})
export class ShellComponent {
  empresas: EmpresaOption[] = [];
  empresaSeleccionada = 0;

  constructor(readonly auth: AuthService) {}

  ngOnInit(): void {
    this.empresaSeleccionada = this.auth.user()?.idEmpresaActiva ?? this.auth.user()?.idEmpresa ?? 0;
    if (this.isSuperAdmin()) {
      this.auth.empresasDisponibles().subscribe((empresas) => {
        this.empresas = empresas;
        if (!this.empresaSeleccionada && empresas.length > 0) {
          this.empresaSeleccionada = empresas[0].idEmpresa;
          this.onEmpresaChange(this.empresaSeleccionada);
        }
      });
    }
  }

  isSuperAdmin(): boolean {
    return this.auth.user()?.idRol === 1;
  }

  isAdmin(): boolean {
    const rol = this.auth.user()?.idRol ?? 3;
    return rol === 1 || rol === 2;
  }

  onEmpresaChange(idEmpresa: number): void {
    const empresa = this.empresas.find((item) => item.idEmpresa === Number(idEmpresa));
    if (!empresa) {
      return;
    }

    this.auth.cambiarEmpresaActiva(empresa).subscribe(() => {
      window.location.reload();
    });
  }
}
